// ============================================================================
// Triage-Ops API client (admin).
//
// Backend routes (backend/chatbot/urls.py):
//   GET  /api/chat/triage-queue/                          intents awaiting scheduling
//   POST /api/chat/triage-queue/{intentId}/schedule/  {slot_id}   -> creates booking
//
// Red and other flagged AI-triage intents are NOT patient self-booked; an admin
// schedules them here, which links the RAG grade + clinician summary to the
// real appointment so it surfaces on the doctor's queue.
// ============================================================================

import { api } from './client.js'

export async function listTriageQueue() {
  const { data } = await api.get('/api/chat/triage-queue/')
  return data.results || []
}

export async function scheduleTriageIntent(intentId, slotId) {
  const { data } = await api.post(`/api/chat/triage-queue/${intentId}/schedule/`, {
    slot_id: slotId,
  })
  return data
}
